<template>
  <div>
    <h5
      v-if="group.name"
      class="text-uppercase mb-3"
    >
      {{ group.name }}
    </h5>
    <div class="box-content mb-5">
      <template
        v-for="item in filtered(group.items)"
      >
        <extra-equipmen-with-price
          v-if="item.ADDFlag === 2"
          :key="item.ADDID"
          :item="item"
        />
        <extra-equipment-in-package
          v-else
          :key="item.ADDID"
          :item="item"
        />
      </template>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { Component, Prop } from 'vue-property-decorator';
  import ExtraEquipmenWithPrice from './ExtraEquipmenWithPrice';
  import ExtraEquipmentInPackage from './ExtraEquipmentInPackage';
  import { namespace } from 'vuex-class';

  const configuratorModule = namespace('configurator');

  @Component({
    components: {ExtraEquipmentInPackage, ExtraEquipmenWithPrice}
  })
  export default class ExtraEquipmentGroup extends Vue {
    @Prop(Object) group;

    @configuratorModule.State('stockMode') stockMode;
    @configuratorModule.State('selectedEquipments') selectedEquipments;

    filtered(items) {
      if (!this.stockMode) {
        return items;
      }

      return items.filter(item => this.selectedEquipments.includes(item.ADDID))
    }
  }
</script>
